@if (formGroup) {
  <app-number-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    (onChange)="onChange($event)"
  ></app-number-control>
}
